const REWRITE_MAX_CHARS = 80_000;
const ANNOTATION_MAX_COMBINED = 160_000;
const ANNOTATION_MAX_PER_DOC = 80_000;
const HEAD_RATIO = 0.83;
const OMISSION_MARKER = '\n\n[... middle sections omitted for brevity ...]\n\n';

function smartTruncate(text: string, maxLen: number): string {
  if (text.length <= maxLen) return text;
  const headLen = Math.floor(maxLen * HEAD_RATIO);
  const tailLen = maxLen - headLen - OMISSION_MARKER.length;
  if (tailLen < 500) {
    return text.slice(0, maxLen - OMISSION_MARKER.length) + OMISSION_MARKER;
  }
  console.warn(`Document truncated from ${text.length} to ~${maxLen} characters`);
  return text.slice(0, headLen) + OMISSION_MARKER + text.slice(text.length - tailLen);
}

export function truncateForRewrite(documentText: string): string {
  return smartTruncate(documentText, REWRITE_MAX_CHARS);
}

export function truncateForAnnotation(
  original: string,
  rewritten: string,
): { original: string; rewritten: string } {
  const combined = original.length + rewritten.length;
  if (combined <= ANNOTATION_MAX_COMBINED) {
    return { original, rewritten };
  }
  return {
    original: smartTruncate(original, ANNOTATION_MAX_PER_DOC),
    rewritten: smartTruncate(rewritten, ANNOTATION_MAX_PER_DOC),
  };
}
